import React, { useEffect, useRef, useState } from "react";
import "../styles/Cursor.css";

const Cursor = () => {
    const cursorRef = useRef(null);
    const followerRef = useRef(null);

    const mouse = useRef({ x: 0, y: 0 });
    const posCursor = useRef({ x: 0, y: 0 });
    const posFollower = useRef({ x: 0, y: 0 });

    const hasMoved = useRef(false);
    const size = 30;

    const [isActive, setIsActive] = useState(window.innerWidth >= 992);
    const animationRef = useRef(null);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 992px)");

        const handleMediaChange = (e) => {
            setIsActive(e.matches);
        };

        mediaQuery.addEventListener("change", handleMediaChange);
        setIsActive(mediaQuery.matches); // pour init au mount

        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, []);

    useEffect(() => {
        if (!isActive) {
            if (cursorRef.current) cursorRef.current.style.display = "none";
            if (followerRef.current) followerRef.current.style.display = "none";
            cancelAnimationFrame(animationRef.current);
            return;
        }

        if (cursorRef.current) cursorRef.current.style.display = "block";
        if (followerRef.current) followerRef.current.style.display = "block";

        const moveCursor = (e) => {
            mouse.current = { x: e.clientX - size / 2, y: e.clientY - size / 2 };

            if (!hasMoved.current) {
                hasMoved.current = true;
                posCursor.current = { ...mouse.current };
                posFollower.current = { ...mouse.current };

                cursorRef.current.style.visibility = "visible";
                followerRef.current.style.visibility = "visible";
            }
        };

        const animate = () => {
            posCursor.current.x += (mouse.current.x - posCursor.current.x) * 0.05;
            posCursor.current.y += (mouse.current.y - posCursor.current.y) * 0.05;

            posFollower.current.x += (mouse.current.x - posFollower.current.x) * 0.2;
            posFollower.current.y += (mouse.current.y - posFollower.current.y) * 0.2;

            if (cursorRef.current) {
                cursorRef.current.style.left = `${posCursor.current.x}px`;
                cursorRef.current.style.top = `${posCursor.current.y}px`;
            }
            if (followerRef.current) {
                followerRef.current.style.left = `${posFollower.current.x}px`;
                followerRef.current.style.top = `${posFollower.current.y}px`;
            }

            animationRef.current = requestAnimationFrame(animate);
        };

        const handleHover = (e) => {
            const interactive = e.target.closest("a, button, .interactive");
            if (interactive) {
                cursorRef.current.classList.add("hovered");
                followerRef.current.classList.add("hovered");
            } else {
                cursorRef.current.classList.remove("hovered");
                followerRef.current.classList.remove("hovered");
            }
        };

        window.addEventListener("mousemove", moveCursor);
        document.addEventListener("mouseover", handleHover);
        document.addEventListener("mouseout", handleHover);

        animate();

        return () => {
            window.removeEventListener("mousemove", moveCursor);
            document.removeEventListener("mouseover", handleHover);
            document.removeEventListener("mouseout", handleHover);
            cancelAnimationFrame(animationRef.current);
        };
    }, [isActive]);

    return (
        <>
            <div ref={cursorRef} className="cursor" style={{ display: isActive ? "block" : "none" }} />
            <div ref={followerRef} className="follower" style={{ display: isActive ? "block" : "none" }} />
        </>
    );
};

export default Cursor;
